// extracted by mini-css-extract-plugin
module.exports = {"root":"BottomNav_root__RF12L","tab":"BottomNav_tab__PT_Ic","active":"BottomNav_active__9b_yr","label":"BottomNav_label__6UDtq"};